import React from "react";
import { Container, Row } from "react-bootstrap";
import CommunityWork from "./CommunityWork";
// import { community } from "../Models";

function Community() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading" style={{paddingBottom: "20px"}}>
          <strong>Community</strong> Contributions
        </h1>
        <Row style={{padding: "10px" }} class="d-flex justify-content-around">

        <CommunityWork />
          
        </Row>
      </Container>
    </Container>
  );
}

export default Community;
